import { useMemo } from 'react';
import rtlDetect from 'rtl-detect';

const getLocale = () => 'en';

export interface Locale {
  locale: string;
  direction: 'ltr' | 'rtl';
}

export const useLocale = (): Locale => {
  const locale = getLocale();

  return useMemo(
    () => ({
      locale: locale,
      direction: rtlDetect.isRtlLang(locale) ? 'rtl' : 'ltr'
    }),
    [locale]
  );
};
